module.exports = __webpack_public_path__ + "c28cbf920be0b531c63a17407400d4d2.mp4";